import React from 'react';
import { identity } from 'lodash';
import { CounterProps } from './types';

/**
 * @deprecated Please use Counter from @fiverr-private/data_display instead.
 */
const Counter = ({ current, max, className, format = identity }: CounterProps) => {
    const formattedCurrent = format(current, {
        fallbackValue: current,
        noFractionDigits: true
    });
    const formattedMax = max && format(max, {
        fallbackValue: max,
        noFractionDigits: true
    });
    const content = max ? `${formattedCurrent}/${formattedMax}` : formattedCurrent;

    return (
        <span className={className}>
            {content}
        </span>
    );
};

Counter.displayName = 'Counter';

export default Counter;
